export default __webpack_public_path__ + "static/media/left.5f59a2f5.svg";